import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadCompany } from "../store/actions/company/index";
import { fetchBusinessConsultants } from "../store/actions/connections";
import { identifyUserAndAccount } from "../libs/utils";
import { getCurrentCookieConsents } from "../libs/cookie-consent-utils";
import sha256 from "sha256";

const useGetCompanies = () => {
  const auth = useSelector((state) => state.auth);
  const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);
  const user = useSelector((state) => state.user);

  const dispatchAction = useDispatch();

  const setCommercialistiClientList = (idVal) => {
    dispatchAction(fetchBusinessConsultants(auth, idVal)).then((accountant) => {
      if (accountant.data && accountant.data.length > 0) {
        localStorage.setItem("studioSelected", accountant.data[0].codiceFiscale);
        localStorage.setItem("selectedAccountantID", accountant.data[0].id);
        localStorage.setItem("actualAccountantName", accountant.data[0].ragioneSociale);
        dispatchAction({
          type: "changeAccountant",
          accountantUuidSelected: accountant.data[0].uuid,
          accountantIdSelected: accountant.data[0].id,
          accountantSelected: accountant.data[0].codiceFiscale,
        });
        dispatchAction({
          type: "changeAccountant",
          accountantUuidSelected: accountant.data[0].uuid,
          accountantIdSelected: accountant.data[0].id,
          accountantSelected: accountant.data[0].codiceFiscale,
        });
      }
    });
  };

  const getCompanies = useCallback(
    (userType, studioArr, accountantID) => {
      if (userType === "STUDIO" && (main.companiesRequestPage < 0 || !main.accountantIdSelected || !auth)) return undefined;
      return dispatchAction(
        loadCompany(
          main.companiesRequestText,
          main.companiesRequestPage,
          main.companiesRequestSize,
          // se ho effettuato gia una ricerca devo mandare il blocco di prericerca
          company.preSearchedCompany && company.preSearchedCompany.length > 0 ? company.preSearchedCompany : company.companies
        )
      ).then((companies) => {
        if (main.companiesRequestText !== "" || main.companiesRequestPage > 0 || companies.length === 0) {
          return null;
        }

        let preSelectedClient = companies.filter((e) => {
          return e.id === localStorage.getItem("selectedClientID");
        });

        preSelectedClient = preSelectedClient.length > 0 ? preSelectedClient[0] : companies[0];

        if (userType !== "STUDIO") {
          setCommercialistiClientList(preSelectedClient.id);
        } else {
          // se gestisco un solo studio setto l'accountant
          if (userType === "STUDIO" && studioArr && studioArr.length === 1) {
            // localStorage.setItem("studioSelected", accountantCF);
            localStorage.setItem("selectedAccountantID", accountantID);
            dispatchAction({
              type: "changeAccountant",
              accountantUuidSelected: studioArr[0].uuid,
              accountantIdSelected: studioArr[0].id,
              accountantSelected: studioArr[0].codiceFiscale,
            });
          }
        }

        if (!main.companyUuidSelected) {
          localStorage.setItem("selectedClient", preSelectedClient.codiceFiscale);
          localStorage.setItem("selectedClientID", preSelectedClient.id);

          dispatchAction({
            type: "changeCompany",
            companyUuidSelected: preSelectedClient.uuid,
            clientIdSelected: preSelectedClient.id,
            companySelected: preSelectedClient.codiceFiscale,
            myType: userType !== "STUDIO" ? preSelectedClient.classifier : "STUDIO",
          });
        }

        const { C0005: profilingCookiesAccepted } = getCurrentCookieConsents();
        const normalizeAndHash = (s) => s && sha256(s.toLowerCase().trim());

        identifyUserAndAccount({
          user: {
            id: normalizeAndHash(auth?.loginAuth?.id),
            email: profilingCookiesAccepted ? user?.profile?.tsid : "Email",
            firstName: profilingCookiesAccepted ? user?.profile?.firstName : "FirstName",
            lastName: profilingCookiesAccepted ? user?.profile?.lastName : "LastName",
            userConsent: profilingCookiesAccepted,
          },
          account: {
            id:
              userType !== "STUDIO"
                ? normalizeAndHash(`ONEP_CORE_REGISTRY_ITEM_${preSelectedClient.id}`)
                : normalizeAndHash(`ONEP_CORE_REGISTRY_ITEM_${studioArr[0].id}`),
            // uuid: userType !== "STUDIO" ? preSelectedClient.id : studioArr[0].id,
            name: profilingCookiesAccepted ? (userType !== "STUDIO" ? preSelectedClient.ragioneSociale : studioArr[0].ragioneSociale) : "name",
            ONEP_CORE_REGISTRY_ITEM_taxIdentifier: profilingCookiesAccepted
              ? userType !== "STUDIO"
                ? preSelectedClient.codiceFiscale
                : studioArr[0].codiceFiscale
              : "taxId",
            ONEP_CORE_REGISTRY_ITEM_vatIdentifier: profilingCookiesAccepted
              ? userType !== "STUDIO"
                ? preSelectedClient.partitaIva
                : studioArr[0].partitaIva
              : "vatNumber",
          },
        });
        return undefined;
      });
    },
    [
      main?.companiesRequestText,
      main?.accountantIdSelected,
      main?.companiesRequestPage,
      main.companyUuidSelected,
      main?.companiesRequestSize,
      main?.userType,
      auth?.loginAuth?.id,
    ]
  );

  return {
    getCompanies: (userType, studioArr, accountantID) => getCompanies(userType, studioArr, accountantID),
    setCommercialistiClientList: (idVal) => setCommercialistiClientList(idVal),
  };
};

export default useGetCompanies;
